<dx-file-uploader #fileUploader
                  uploadUrl="api/Import/ImportSingleMime"
                  [uploadHeaders]="uploadHeaders"
                  [multiple]="false"
                  accept="*"
                  (onBeforeSend)="onBeforeSendUpload($event)"
                  (onUploaded)="onUploaded($event)"
                  [(value)]="value"
                  uploadMode="instantly">
</dx-file-uploader>
<h4>{{ msg }}</h4>

